import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { Link } from "react-router-dom";

export default function Nav() {
  const { locale, setLocale, t } = useI18n();
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.1, duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#050505]/60 border-b border-[#27272A]"
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-8 h-8 bg-[#E1FF00] flex items-center justify-center">
            <span className="font-display font-bold text-[#050505] text-lg leading-none">E</span>
          </div>
          <span className="font-mono-acc text-[10px] sm:text-[11px] tracking-[0.15em] sm:tracking-[0.2em] text-[#F4F4F5] uppercase block">
            Entretien Pro Inc
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <a href="#services" className="font-mono-acc text-[11px] tracking-[0.2em] text-[#A1A1AA] hover:text-[#E1FF00] uppercase transition-colors" data-testid="nav-services">
            {t.nav.services}
          </a>
          <a href="#manifesto" className="font-mono-acc text-[11px] tracking-[0.2em] text-[#A1A1AA] hover:text-[#E1FF00] uppercase transition-colors" data-testid="nav-manifesto">
            {t.nav.manifesto}
          </a>
          <a href="#contact" className="font-mono-acc text-[11px] tracking-[0.2em] text-[#A1A1AA] hover:text-[#E1FF00] uppercase transition-colors" data-testid="nav-contact">
            {t.nav.contact}
          </a>
        </nav>

        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1 border border-[#27272A]" data-testid="lang-switch">
            <button
              onClick={() => setLocale("fr")}
              className={`px-2.5 py-1 font-mono-acc text-[10px] tracking-widest uppercase transition-colors ${
                locale === "fr" ? "bg-[#E1FF00] text-[#050505]" : "text-[#A1A1AA] hover:text-[#F4F4F5]"
              }`}
              data-testid="lang-fr"
            >
              FR
            </button>
            <button
              onClick={() => setLocale("en")}
              className={`px-2.5 py-1 font-mono-acc text-[10px] tracking-widest uppercase transition-colors ${
                locale === "en" ? "bg-[#E1FF00] text-[#050505]" : "text-[#A1A1AA] hover:text-[#F4F4F5]"
              }`}
              data-testid="lang-en"
            >
              EN
            </button>
          </div>
          <a
            href="#quote"
            className="hidden sm:inline-flex items-center gap-2 bg-[#E1FF00] hover:bg-[#CBE600] text-[#050505] px-4 py-2.5 font-mono-acc text-[11px] tracking-[0.15em] uppercase font-medium transition-colors"
            data-testid="nav-quote-cta"
          >
            {t.nav.quote}
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
}
